import { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'antd/lib/button';

import { PageWrapper } from 'modules/layout';
import config from 'config/index';

import NewsList from '../../containers/NewsList';

const NewsListPage = ({ history: { push } }) => (
    <PageWrapper
        header={
            <Fragment>
                <FormattedMessage id="news.title" />
                <Button
                    type="primary"
                    onClick={() => {
                        push(config.routes.newsAdd);
                    }}
                >
                    <FormattedMessage id="news.add.button" />
                </Button>
            </Fragment>
        }
    >
        <NewsList />
    </PageWrapper>
);

NewsListPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default NewsListPage;
